'use client';

import React from 'react';
import classnames from 'classnames';
import styles from './Col.module.scss';

/**
 * ##Import
 * `import Col from "components/common/atoms/Grid/Col/Col";`
 */

type ColSpan = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;

export interface ColProps extends React.HTMLAttributes<HTMLDivElement> {
  /**
   * Raster number of cells to occupy, 0 corresponds to display: none
   */
  span?: ColSpan;
  /**
   * screen < 320 and also default setting, could be a span value
   */
  xs?: ColSpan;
  /**
   * screen > 321px, could be a span value
   */
  sm?: ColSpan;
  /**
   * screen > 768px, could be a span value
   */
  md?: ColSpan;
  /**
   * screen > 1024px, could be a span value
   */
  lg?: ColSpan;
  /**
   * screen > 1280px, could be a span value
   */
  xl?: ColSpan;
  /**
   * screen > 1440px, could be a span value
   */
  xxl?: ColSpan;
  children?: React.ReactNode;
  className?: string;
}

const Col: React.FC<ColProps> = ({
  span,
  xs = 12,
  sm,
  md,
  lg,
  xl,
  xxl,
  children,
  className,
  ...props
}) => {
  return (
    <div
      className={classnames(
        styles.col,
        {
          [styles[`col-${span}`]]: span !== undefined && !isNaN(span),
          [styles[`col-xs-${xs}`]]: xs !== undefined && !isNaN(xs),
          [styles[`col-sm-${sm}`]]: sm !== undefined && !isNaN(sm),
          [styles[`col-md-${md}`]]: md !== undefined && !isNaN(md),
          [styles[`col-lg-${lg}`]]: lg !== undefined && !isNaN(lg),
          [styles[`col-xl-${xl}`]]: xl !== undefined && !isNaN(xl),
          [styles[`col-xxl-${xxl}`]]: xxl !== undefined && !isNaN(xxl),
        },
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
};

Col.displayName = 'Col';

export default Col;
